import { render, staticRenderFns } from "./ImportErrorAlert.vue?vue&type=template&id=27a9ec73&scoped=true&"
import script from "./ImportErrorAlert.vue?vue&type=script&lang=js&"
export * from "./ImportErrorAlert.vue?vue&type=script&lang=js&"
import style0 from "./ImportErrorAlert.vue?vue&type=style&index=0&id=27a9ec73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9ec73",
  null
  
)

export default component.exports